import api from '../services/api'

export const getInstagramFeed = () => {
  return api.get('/instagram-feed').then((res) => res.data.data.data)
}
